import CollapsedCard from './CollpasedCard';
import Amount from './Amount';
import BreakdownTip from './BreakdownTip';
import { BarTarget } from './ActionBar';

// The key of a tactic in play as the action bar's Tactic button picks it (copying it): by its name, as copies of a
// tactic are one, except a card that has gained strength (Sun Tzu), which is its own (see the engine's ActionBar.js)
const TacticKey = (tactic) => `tactic:${tactic.bonus > 0 ? tactic.card.id : tactic.card.name}`;

// On every board, for everyone: each civilization's military strength, strongest first (ties go to the earlier in
// turn order, so the list shows who would win one), and the tactics everyone may use, small (as in hand), each with
// the markers of those on it beside it. They stay in the order they came into play, so playing one moves nothing.
// Bar: the action bar, while its Tactic button picks a tactic to copy here
function MilitaryArea({Military, PlayerColors, CubeColors, Bar, GameEngine})
{
    // (a tactic in play, with static buttons and no trigger on: what copying it costs, and why it can't be copied)
    const handOf = (tactic) => !Bar?.active ? Bar?.hand?.[TacticKey(tactic)] : null;
    if (!Military)
    {
        return null;
    }
    return (
        <div className="tta tta-left tta-military-area">
            <div className="tta-since-title">Military</div>
            {/* Strongest first, on one line */}
            <div className="tta-military-ranking">
                {Military.ranking.map((entry, index) =>
                    // (where the strength comes from, its tactic included, on hover: as on the civilization's own board)
                    <BreakdownTip As="span" key={entry.player} breakdown={entry.breakdown}>
                        <span className="tta-muted">{index + 1}.</span>{' '}
                        <span style={{ color: PlayerColors[entry.player], fontWeight: 'bold' }}>{entry.name}</span>{' '}
                        <Amount value={entry.strength} kind="strength" title=""/>
                        {/* (e.g. Nostradamus's +3 when defending; Himeji Castle's unit it may add) */}
                        {(entry.extras ?? []).map(extra =>
                            <span key={extra.source} className="tta-ranking-extra" title={`${extra.source}: ${extra.upTo ? 'up to ' : ''}+${extra.value} ${extra.when.join(', and ')}`}>
                                ({extra.upTo ? '≤' : ''}+{extra.value})</span>)}
                    </BreakdownTip>)}
            </div>
            {Military.tactics.length > 0 && <div className="tta-since-title" style={{ marginTop: '6px' }}>Tactics</div>}
            {Military.tactics.length > 0 &&
                <div className="tta-military-tactics">
                    {Military.tactics.map(tactic =>
                        <BarTarget key={tactic.card.id ?? tactic.card.name} Bar={Bar} TargetKey={TacticKey(tactic)} GameEngine={GameEngine}>
                            <div className="tta-tactic-line">
                                {/* (with static buttons and no trigger on: clicked to copy it, why not in its hover) */}
                                <CollapsedCard card={tactic.card} Cost={handOf(tactic)?.cost} Usable={handOf(tactic)?.selectable} Note={handOf(tactic)?.reason}/>
                                {/* Who is on it (how many armies that player's units form for it: in the tooltip) */}
                                {tactic.players.length > 0 &&
                                    <div className="tta-tactic-line-markers">
                                        {tactic.players.map(player =>
                                            <span key={player} className="tta-tactic-marker-wrap" title={`On this tactic${tactic.armies?.[player] ? `: ${tactic.armies[player]} arm${tactic.armies[player] === 1 ? 'y' : 'ies'}` : ''}`}>
                                                <span className="tta-tactic-marker" style={{ backgroundColor: CubeColors[player] }}/>
                                            </span>)}
                                    </div>}
                            </div>
                        </BarTarget>)}
                </div>}
        </div>
    );
}

export default MilitaryArea;
